import { Captura, Section } from "./comunes";

// Sección de ayuda: Guías (base de conocimiento interna)
// Cubre: qué son, estados y etiquetas, el editor (imágenes, videos, tablas,
// importar .md), y la exportación a PDF con membrete (saltos de página,
// ajustar a 1 hoja y orientación de hoja por guía).

export default function AyudaGuias() {
  return (
    <>
      <Section id="guias" title="Guías (base de conocimiento)">
        <p>
          Las <strong>Guías</strong> son el conocimiento del equipo: cómo se da
          soporte, cómo se hacen las pruebas, procedimientos de configuración,
          comandos por modelo. Cualquiera del equipo las puede leer;{" "}
          <strong>soporte y admin</strong> las crean (cada quien edita las
          suyas; admin edita todas).
        </p>
        <Captura
          src="/ayuda-img/guia-detalle.png"
          alt="Vista de una guía"
          caption="Una guía publicada: título, etiquetas, y arriba a la derecha Ver PDF / descargar PDF / Editar."
        />
        <ul className="list-disc list-inside space-y-1">
          <li>
            <strong>Borrador vs. Publicado</strong>: el borrador es trabajo en
            progreso; lo publicado es la referencia oficial del equipo. El
            estado se cambia al pie del editor.
          </li>
          <li>
            <strong>Etiquetas</strong>: clasifican y filtran (ej.{" "}
            <em>configuración</em>, <em>queclink</em>). En la lista, click en
            un chip para filtrar; con varios chips solo salen las guías que
            tengan TODOS.
          </li>
          <li>
            <strong>Buscar</strong>: el buscador de la lista busca en título,
            contenido y etiquetas.
          </li>
        </ul>

        <h3 className="font-semibold mt-4 mb-1">El editor</h3>
        <Captura
          src="/ayuda-img/guia-editor.png"
          alt="Editor de guías con su barra de herramientas"
          caption="La barra del editor: formato, enlaces, imágenes, YouTube, tablas, separador, y las herramientas de PDF (⤓ salto de página, ⤢ 1 hoja, ▭/▯ orientación)."
        />
        <ul className="list-disc list-inside space-y-1">
          <li>
            <strong>Imágenes</strong>: pega desde el portapapeles o arrastra el
            archivo al editor; jala la esquina para redimensionar (el tamaño se
            respeta también en el PDF).
          </li>
          <li>
            <strong>Videos de YouTube</strong>: pega la liga con el botón{" "}
            <strong>▶ YouTube</strong> — quedan embebidos en la vista web; en
            el PDF salen como un cuadro con la liga.
          </li>
          <li>
            <strong>Tablas con columna de comandos</strong>: inserta con{" "}
            <strong>▦</strong>; pon el cursor en la columna del comando y
            márcala con <strong>⧉</strong> — al ver la guía, cada fila trae su
            botón de copiar de un clic, y la columna entera se copia con{" "}
            <strong>⧉ copiar las N</strong>: en la computadora está en el
            encabezado de la columna y en el celular, arriba de la tabla (ahí
            cada fila se ve como tarjeta y el encabezado no aparece). Copia una
            liga por renglón, con el nombre por delante. Dentro de la tabla usa{" "}
            <strong>+col / −col / +fila / −fila</strong>.
          </li>
          <li>
            <strong>Importar .md</strong>: el botón <strong>↑ .md</strong>{" "}
            inserta un archivo Markdown completo (títulos, tablas, código) en
            la posición del cursor.
          </li>
        </ul>

        <h3 className="font-semibold mt-4 mb-1">Exportar a PDF (para el cliente)</h3>
        <p>
          <strong>Ver PDF</strong> lo abre en el visor y <strong>↓ PDF</strong>{" "}
          lo descarga, con membrete Emprenet (logo, marca de agua y folio de
          página). Si la guía trae un índice con enlaces a sus secciones, en el
          PDF esos enlaces también saltan. Nada de esto cambia cómo se ve la
          guía en la web — son herramientas solo del PDF:
        </p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>
            <strong>⤓ Salto de página</strong>: lo que siga arranca arriba de
            una hoja nueva. Si una sección se pasa tantito de su hoja, el PDF
            la comprime suavecito para que quepa completa — así no quedan
            hojas casi vacías con 2-3 líneas sueltas.
          </li>
          <li>
            <strong>⤢ 1 hoja</strong>: selecciona una sección y haz clic — en
            el PDF esa sección se ajusta para llenar UNA sola hoja, como el
            "ajustar a la página" de una impresora: si no cabe se encoge
            (letra e imágenes en proporción, con piso de legibilidad) y si
            sobra espacio la letra crece un poco para llenarla (las tablas
            conservan su tamaño).
          </li>
          <li>
            <strong>▭ PDF horizontal / ▯ PDF vertical</strong>: la hoja del
            PDF de ESTA guía. Horizontal luce con tablas anchas de comandos;
            vertical con texto y capturas. Se guarda con la guía y la puedes
            cambiar cuando quieras (clic para alternar y Guardar).
          </li>
        </ul>

        <h3 className="font-semibold mt-4 mb-1">Las guías que vienen de Queclink</h3>
        <p>
          53 guías salieron de la base de conocimiento del proveedor y se
          actualizan solas cada día. Se reconocen por sus tags{" "}
          <strong>QUECLINK</strong> e <strong>IMPORTADA</strong>, y por el aviso{" "}
          <em>«Traída de la base de conocimiento de Queclink»</em> arriba del
          contenido. Entran todas en <strong>borrador</strong> a propósito: son
          documentación del fabricante sin revisar, no know-how nuestro —
          publícalas conforme las vayas validando.
        </p>
        <p className="mt-2">
          <strong>Puedes editarlas con confianza.</strong> Si Queclink cambia un
          artículo que tú ya customizaste, tu versión{" "}
          <strong>no se sobrescribe</strong>: la actualización llega como una
          guía nueva en borrador, con el título terminado en{" "}
          <em>«— actualización de Queclink»</em>, y tú decides qué te llevas. Si
          no la habías tocado, se actualiza sola y ya.
        </p>
        <p className="mt-2">
          Vienen en <strong>español</strong> salvo dos que Queclink solo publica
          en inglés (el tag <strong>EN-US</strong> las distingue). Las imágenes y
          los videos se guardan de nuestro lado, así que se ven aunque el
          proveedor cambie su sitio. Los administradores tienen el botón{" "}
          <strong>↻ Queclink</strong> en la lista de Guías para traer lo nuevo
          sin esperar a la corrida del día.
        </p>
      </Section>
    </>
  );
}
